import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { ReservationFlowProductDetail } from 'src/interfaces/reservation_flow';

export interface ProductSummaryProps {
  productDetail: ReservationFlowProductDetail;
}

export const ProductSummary: FC<ProductSummaryProps> = ({ productDetail }) => {
  const intl = useIntl();

  return (
    <div>
      <div className="flex items-center">
        {productDetail.image_url && (
          <div className="mr-1.5 flex-none">
            <img
              className="box-border block h-[56px] rounded-[6px]"
              src={productDetail.image_url}
              alt=""
            />
          </div>
        )}

        <div className="flex-auto">
          <div className="mb-0.5">
            <div className="rs-font text-16 text-gray-1000 pc:text-15 font-bold">
              {productDetail.name}
            </div>
          </div>
          <div>
            <div className="rs-font text-16 text-gray-1000 pc:text-15 font-normal">
              {productDetail.scheme === 'subscription' &&
                intl.formatMessage({
                  defaultMessage: '月額：',
                  id: 'mqCYHt',
                  description:
                    'src/templates/merchants/resources/book/components/product-purchase-modal/SubscriptionPurchaseModal/components/ProductSummary/index.tsx',
                })}
              {intl.formatMessage(
                {
                  defaultMessage: '{priceString}（税込）',
                  id: 'RF18cK',
                  description:
                    'src/templates/merchants/resources/book/components/product-purchase-modal/SubscriptionPurchaseModal/components/ProductSummary/index.tsx',
                },
                {
                  priceString: intl.formatNumber(productDetail.price, {
                    style: 'currency',
                    currency: 'JPY',
                  }),
                },
              )}
            </div>
          </div>
        </div>
      </div>

      {productDetail.scheme === 'ticket_book' && (
        <div className="mt-1.5">
          <div className="rs-font text-13 text-gray-1000 pc:text-12 font-normal">
            {intl.formatMessage(
              {
                defaultMessage:
                  '利用可能数：{ticketCount}回 / 有効期限：{expirationMonth}ヶ月',
                id: 'laD+sE',
                description:
                  'src/templates/merchants/resources/book/components/product-purchase-modal/SubscriptionPurchaseModal/components/ProductSummary/index.tsx',
              },
              {
                ticketCount: productDetail.ticket_count,
                expirationMonth: productDetail.expiration_month,
              },
            )}
          </div>
        </div>
      )}
    </div>
  );
};
